import * as React from 'react';
import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';
import { PriceFormatted } from '@estee/elc-formatters';
import { classes } from '../../utils/Classes';
import { VTO_PRODUCT_PRICE } from '../../constants/DataTestIdAttributes';

export interface IPriceFormatted {
    className?: string;
    formattedPrice: string;
    formattedOriginalPrice?: string;
}

const ProductPriceRowWrapper = styled.div`
    display: inline-block;
    margin-right: ${ContentSpacing.space16};
`;

const productPriceRowWrapperClassNames = classes('product-price-row-wrapper');
const productOriginalPriceClassNames = classes('product-original-price');
const productPriceClassNames = classes('product-price');

export const ProductPriceFormatted = (props: IPriceFormatted) => {
    const { formattedPrice, formattedOriginalPrice } = props;

    return (
        <ProductPriceRowWrapper
            data-test-id={VTO_PRODUCT_PRICE}
            className={productPriceRowWrapperClassNames}
        >
            {formattedOriginalPrice && (
                <PriceFormatted
                    className={productOriginalPriceClassNames}
                    formattedPrice={formattedOriginalPrice}
                    isDiscounted={!!formattedPrice}
                />
            )}
            {formattedPrice && (
                <PriceFormatted
                    className={productPriceClassNames}
                    formattedPrice={formattedPrice}
                    priceTag="p"
                />
            )}
        </ProductPriceRowWrapper>
    );
};
